import { Controller } from '@hotwired/stimulus';


export default class extends Controller {
  static targets = ['values', 'chips', 'chipTemplate'];

  pick(event) {
    const { value, label } = event.detail;
    if (!value) return;

    const field = this.selectField();
    if (this.hasValue(value)) {
      field?.reset();
      return;
    }

    this.appendChip(value, label);
    this.appendHiddenInput(value);
    field?.take(value);
    field?.reset();
    this.chipsTarget.hidden = false;
    this.announceChange();
    this.dispatch('added', { detail: { value, label } });
  }

  remove(event) {
    const value = String(event.params.value);
    const item = event.target.closest('.ui-search-input__item');
    const label = item.querySelector('.ui-chip__label').textContent.trim();

    item.remove();

    this.valuesTarget.querySelectorAll('input').forEach((input) => {
      if (input.value === value) input.remove();
    });

    this.selectField()?.release(value, label);

    if (!this.chipsTarget.querySelector('.ui-search-input__item')) {
      this.chipsTarget.hidden = true;
    }

    this.announceChange();
    this.dispatch('removed', { detail: { value, label } });
  }


  appendChip(value, label) {
    const item = this.chipTemplateTarget.content.firstElementChild.cloneNode(true);
    item.dataset.value = value;
    item.querySelector('.ui-chip__label').textContent = label;

    const removeButton = item.querySelector('.ui-micro-button');
    removeButton.setAttribute('aria-label', `Remove ${label}`);
    removeButton.setAttribute(`data-${this.identifier}-value-param`, value);

    this.chipsTarget.appendChild(item);
  }

  // Fired from the blank input the list always carries, which outlives every value.
  announceChange() {
    this.valuesTarget.querySelector('input')
      ?.dispatchEvent(new Event('change', { bubbles: true }));
  }

  appendHiddenInput(value) {
    const sentinel = this.valuesTarget.querySelector('input');
    const input = sentinel.cloneNode();
    input.value = value;
    this.valuesTarget.appendChild(input);
  }

  hasValue(value) {
    return Array.from(this.valuesTarget.querySelectorAll('input'))
      .some((input) => input.value === value);
  }

  selectField() {
    const element = this.element.querySelector('[data-controller~="select-field-component"]');
    if (!element) return null;
    return this.application.getControllerForElementAndIdentifier(element, 'select-field-component');
  }
}
